import { call, put } from "redux-saga/effects";
import BusinessCustomersActions from "./business-customer.reducer";
import * as api from "../../../Service/api";
import { parsePaginatedListResponse } from "../../../utils/paginationUtils";
import { normalizeSubscriberExportCsv, readCsvText } from "../../../utils/subscriberExportCsv";

export function* getBusinessCustomers(action) {
    const { businessId, options } = action;
    // make the call to the api
    const response = yield call(api.getBusinessCustomers, businessId, options);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerAllSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerAllFailure(response.data))
    }
}

export function* getFilteredBusinessCustomers(action) {
    const { businessId, query } = action

    const response = yield call(api.getFilteredBusinessCustomers, businessId, query)

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerSearchSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.businessCustomerSearchFailure(response.data))
    }
}
export function* getBusinessCustomerSummarySearch(action) {
    const { businessId, query } = action

    const response = yield call(api.getBusinessCustomerSummarySearch, businessId, query)

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerSummarySearchSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.businessCustomerSummarySearchFailure(response.data))
    }
}

export function* getBusinessCustomerSummary(action) {
    const { businessId, options } = action

    const response = yield call(api.getBusinessCustomerSummary, businessId, options)

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerSummarySuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.businessCustomerSummaryFailure(response.data))
    }
}

export function* getCustomerSummary(action) {
    const { bcId } = action

    const response = yield call(api.getCustomerSummary, bcId)

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.customerSummarySuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.customerSummaryFailure(response.data))
    }
}

export function* getExactFilteredBusinessCustomers(action) {
    const { businessId, query, options } = action

    const response = yield call(api.getExactFilteredBusinessCustomers, businessId, query, options)

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.exactFilteredBusinessCustomerSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.exactFilteredBusinessCustomersFailure(response.data))
    }
}

export function* updateEnterpriseCustomer(action) {
    const { businessCustomerId, businessCustomer } = action;
    // make the call to the api
    const response = yield call(api.updateEnterpriseCustomers, businessCustomerId, businessCustomer);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerUpdateSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerUpdateFailure(response.data))
    }
}

export function* getBusinessCustomerSubscriptions(action) {
    const { businessCustomerId } = action

    const response = yield call(api.getBusinessCustomerSubscriptions, businessCustomerId)

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerSubscriptionsSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.businessCustomerSubscriptionsFailure(response.data))
    }
}

export function* getBusinessCustomerRecord(action) {
    const { businessCustomerId } = action

    const response = yield call(api.getBusinessCustomerRecord, businessCustomerId)

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerRecordSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.businessCustomerRecordFailure(response.data))
    }
}

export function* getCount(action) {
    const { businessCustomerId } = action

    const response = yield call(api.getBusinessCustomerSubscriptionsCount, businessCustomerId)

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerSubscriptionsCountSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.businessCustomerSubscriptionsCountFailure(response.data))
    }
}
export function* uploadCustomers(action) {
    const { businessId, audienceId, file } = action;
    const response = yield call(api.businessCustomerImport, businessId, audienceId, file);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerUploadSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerUploadFailure(response.data))
    }
}

export function* getImportCustomers(action) {
    const { businessId, options } = action;
    // make the call to the api
    const response = yield call(api.getBusinessCustomerImports, businessId, options);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerImportSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerImportFailure(response.data))
    }
}

export function* downloadSampleCsv() {
    // make the call to the api
    const response = yield call(api.businessCustomerCsvDownload);
    // success?
    if (response.ok) {
        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: 'text/csv' });

        // Create a URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a link element
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'customer_import_template.csv'); // Set the file name

        // Append the link to the body and click it to trigger download
        document.body.appendChild(link);
        link.click();
        yield put(BusinessCustomersActions.downloadCsvSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.downloadCsvFailure(response.data))
    }
}

export function* exportBusinessCustomersCsv(action) {
    const { businessId, query, filename } = action;
    const response = yield call(api.getBusinessCustomersCsv, businessId, query);

    if (response.ok) {
        const csvText = yield call(readCsvText, response.data);
        const blob = new Blob([normalizeSubscriberExportCsv(csvText)], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", filename || "subscribers.csv");
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        link.remove();
        yield put(BusinessCustomersActions.exportBusinessCustomersCsvSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.exportBusinessCustomersCsvFailure(response.data));
    }
}

const statementHeaderTotal = (response) => {
    const headers = response?.headers;
    if (!headers) return null;
    const raw = (typeof headers.get === "function" ? headers.get("X-Total-Count") : null)
        ?? headers["x-total-count"]
        ?? headers["X-Total-Count"];
    if (raw == null || raw === "") return null;
    const parsed = parseInt(raw, 10);
    return Number.isNaN(parsed) ? null : parsed;
};

const withStatementPagination = (response, options = {}) => {
    const data = response?.data;
    if (Array.isArray(data)) {
        const parsed = parsePaginatedListResponse(response, options);
        return {
            entries: parsed.content,
            totalElements: parsed.totalElements,
            totalPages: parsed.totalPages,
        };
    }

    if (data && typeof data === "object") {
        const headerTotal = statementHeaderTotal(response);
        if (data.totalElements == null && data.totalCount == null && headerTotal != null) {
            return { ...data, totalElements: headerTotal };
        }
    }

    return data;
};

export function* getBusinessCustomerStatement(action) {
    const { businessCustomerId, startDate, endDate, options } = action;
    const response = yield call(api.getBusinessCustomerStatement, businessCustomerId, startDate, endDate, options);

    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerStatementSuccess(withStatementPagination(response, options)));
    } else {
        yield put(BusinessCustomersActions.businessCustomerStatementFailure(response.data));
    }
}

export function* getBusinessCustomerStatementCsv(action) {
    const { businessCustomerId, startDate, endDate } = action;
    const response = yield call(api.getBusinessCustomerStatementCsv, businessCustomerId, startDate, endDate);

    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerStatementCsvSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerStatementCsvFailure(response.data));
    }
}

export function* getBusinessCustomerStatementPdf(action) {
    const { businessCustomerId, startDate, endDate } = action;
    const response = yield call(
        api.getBusinessCustomerStatementPdf,
        businessCustomerId,
        startDate,
        endDate
    );

    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerStatementPdfSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerStatementPdfFailure(response.data));
    }
}

export function* downloadAudienceMembersCsv(action) {
    const { audienceId, filename } = action;
    const response = yield call(api.downloadAudienceMembersCsv, audienceId);

    if (response.ok) {
        const blob = response.data instanceof Blob
            ? response.data
            : new Blob([response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", filename || `audience_${audienceId}_members.csv`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        link.remove();
        yield put(BusinessCustomersActions.downloadAudienceMembersCsvSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.downloadAudienceMembersCsvFailure(response.data));
    }
}

export function* createSegment(action) {
    const { segment } = action;

    const response = yield call(api.createSegment, segment);

    if (response.ok) {
        yield put(BusinessCustomersActions.segmentCreateSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.segmentCreateFailure(response.data))
    }
}

export function* updateSegment(action) {
    const { segmentId, segment } = action;

    const response = yield call(api.updateSegment, segmentId, segment);

    if (response.ok) {
        yield put(BusinessCustomersActions.updateSegmentSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.updateSegmentFailure(response.data));
    }
}

export function* getSegment(action) {
    const { businessId, options } = action;

    const response = yield call(api.getSegment, businessId, options);

    if (response.ok) {
        yield put(
            BusinessCustomersActions.segmentSuccess(
                parsePaginatedListResponse(response, options ?? {})
            )
        );
    } else {
        yield put(BusinessCustomersActions.segmentFailure(response.data));
    }
}

export function* searchSegmentsByName(action) {
    const { businessId, name } = action;

    const response = yield call(api.searchSegmentsByName, businessId, name);

    if (response.ok) {
        yield put(BusinessCustomersActions.segmentSearchSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.segmentSearchFailure(response.data));
    }
}

export function* getSegmentCount(action) {
    const { businessId } = action;

    const response = yield call(api.getSegmentCount, businessId);

    if (response.ok) {
        yield put(BusinessCustomersActions.segmentCountSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.segmentCountFailure(response.data))
    }
}

export function* createBusinessCustomer(action) {
    const { businessId, inviteData } = action;

    const response = yield call(api.createBusinessCustomer, businessId, inviteData);

    if (response.ok) {
        yield put(BusinessCustomersActions.createBusinessCustomerSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.createBusinessCustomerFailure(response.data));
    }
}

export function* addSingleSubscriberToSegment(action) {
    const { segmentId, bcId } = action;

    const response = yield call(api.addSingleSubscriberToSegment, segmentId, bcId);

    if (response.ok) {
        yield put(BusinessCustomersActions.addSingleSubToSegmentSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.addSingleSubToSegmentFailure(response.data))
    }
}

export function* addBulkSubscriberToSegment(action) {
    const { segmentId, bcIds } = action;

    const response = yield call(api.addBulkSubscriberToSegment, segmentId, bcIds);

    if (response.ok) {
        yield put(BusinessCustomersActions.addBulkSubToSegmentSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.addBulkSubToSegmentFailure(response.data))
    }
}

export function* removeSubscriberToSegment(action) {
    const { bcId } = action;

    const response = yield call(api.removeSubscriberFromSegment, bcId);

    if (response.ok) {
        yield put(BusinessCustomersActions.removeSubToSegmentSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.removeSubToSegmentFailure(response.data))
    }
}

export function* removeBulkSubscriberToSegment(action) {
    const { bcIds } = action;

    const response = yield call(api.removeBulkSubscribersFromSegment, bcIds);

    if (response.ok) {
        yield put(BusinessCustomersActions.removeBulkSubToSegmentSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.removeBulkSubToSegmentFailure(response.data))
    }
}


export function* getImportCustomersCount(action) {
    const { businessId } = action;
    // make the call to the api
    const response = yield call(api.getBusinessCustomerImportsCount, businessId,);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerImportCountSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerImportCountFailure(response.data))
    }
}

export function* addBulkListToSegment(action) {
    const { id, segmentId } = action;
    // make the call to the api
    const response = yield call(api.addBulkListToSegment, id, segmentId);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.bulkListToSegmentSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.bulkListToSegmentFailure(response.data))
    }
}

export function* sendBulkCustomerPlanInvite(action) {
    const { businessId, inviteData } = action;
    // make the call to the api
    const response = yield call(api.sendBulkInvite, businessId, inviteData);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerBulkPlanInviteSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerBulkPlanInviteFailure(response.data))
    }
}

export function* resendBulkCustomerPlanInvite(action) {
    const { id } = action;
    // make the call to the api
    const response = yield call(api.resendBulkInvitation, id);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerBulkResendInvitationSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerBulkResendInvitationFailure(response.data))
    }
}

export function* getBulkInvitationData(action) {
    const { targetListId } = action;
    // make the call to the api
    const response = yield call(api.getAudienceBulkInvitations, targetListId);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerBulkInvitationSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerBulkInvitationFailure(response.data))
    }
}

export function* getEntries(action) {
    const { importId } = action;
    // make the call to the api
    const response = yield call(api.getBusinessCustomerEntriesList, importId);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerEntrySuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerEntryFailure(response.data))
    }
}

export function* createAudience(action) {
    const { audience } = action;
    const response = yield call(api.createAudience, audience);
    if (response.ok) {
        yield put(BusinessCustomersActions.createAudienceSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.createAudienceFailure(response.data));
    }
}

export function* getAudience(action) {
    const { audienceId } = action;
    const response = yield call(api.getAudienceById, audienceId);
    if (response.ok) {
        yield put(BusinessCustomersActions.audienceSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.audienceFailure(response.data));
    }
}

export function* getAudienceBatches(action) {
    const { audienceId } = action;
    const response = yield call(api.getAudienceBatches, audienceId);
    if (response.ok) {
        yield put(BusinessCustomersActions.audienceBatchesSuccess(normalizeListResponse(response)));
    } else {
        yield put(BusinessCustomersActions.audienceBatchesFailure(response.data));
    }
}

export function* getAudienceMembers(action) {
    const { audienceId, options } = action;
    const response = yield call(api.getAudienceMembers, audienceId, options);
    if (response.ok) {
        yield put(BusinessCustomersActions.audienceMembersSuccess(parsePaginatedListResponse(response, options)));
    } else {
        yield put(BusinessCustomersActions.audienceMembersFailure(response.data));
    }
}

export function* addAudienceMember(action) {
    const { audienceId, businessCustomerId } = action;
    const response = yield call(api.addAudienceMember, audienceId, businessCustomerId);
    if (response.ok) {
        yield put(BusinessCustomersActions.addAudienceMemberSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.addAudienceMemberFailure(response.data));
    }
}

const normalizeListResponse = (response) => {
    const data = response.data;
    if (Array.isArray(data)) {
        return data;
    }
    if (data?.content && Array.isArray(data.content)) {
        return data.content;
    }
    return [];
};

export function* removeAudienceMember(action) {
    const { audienceId, memberId } = action;
    const response = yield call(api.removeAudienceMember, audienceId, memberId);
    if (response.ok) {
        yield put(BusinessCustomersActions.removeAudienceMemberSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.removeAudienceMemberFailure(response.data));
    }
}

export function* getAudienceCandidateSegments(action) {
    const { audienceId } = action;
    const response = yield call(api.getAudienceCandidateSegments, audienceId);
    if (response.ok) {
        yield put(BusinessCustomersActions.audienceCandidateSegmentsSuccess(normalizeListResponse(response)));
    } else {
        yield put(BusinessCustomersActions.audienceCandidateSegmentsFailure(response.data));
    }
}

export function* getAudienceCandidateTags(action) {
    const { audienceId } = action;
    const response = yield call(api.getAudienceCandidateTags, audienceId);
    if (response.ok) {
        yield put(BusinessCustomersActions.audienceCandidateTagsSuccess(normalizeListResponse(response)));
    } else {
        yield put(BusinessCustomersActions.audienceCandidateTagsFailure(response.data));
    }
}

export function* saveAudienceCandidateMetadata(action) {
    const { audienceId, metadata } = action;
    const response = yield call(api.saveAudienceCandidateMetadata, audienceId, metadata);
    if (response.ok) {
        yield put(BusinessCustomersActions.saveAudienceCandidateMetadataSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.saveAudienceCandidateMetadataFailure(response.data));
    }
}

export function* applyAudienceCandidates(action) {
    const { audienceId } = action;
    const response = yield call(api.applyAudienceCandidates, audienceId);
    if (response.ok) {
        yield put(BusinessCustomersActions.applyAudienceCandidatesSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.applyAudienceCandidatesFailure(response.data));
    }
}

export function* deleteAudienceCandidateSegment(action) {
    const { audienceId, candidateSegmentId } = action;
    const response = yield call(api.deleteAudienceCandidateSegment, audienceId, candidateSegmentId);
    if (response.ok) {
        yield put(BusinessCustomersActions.deleteAudienceCandidateSegmentSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.deleteAudienceCandidateSegmentFailure(response.data));
    }
}

export function* deleteAudienceCandidateTag(action) {
    const { audienceId, candidateTagId } = action;
    const response = yield call(api.deleteAudienceCandidateTag, audienceId, candidateTagId);
    if (response.ok) {
        yield put(BusinessCustomersActions.deleteAudienceCandidateTagSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.deleteAudienceCandidateTagFailure(response.data));
    }
}

export function* applyImport(action) {
    const { id, batchNo } = action;
    const response = yield call(api.applyBusinessCustomerImport, id, batchNo);

    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerApplySuccess(response.data, batchNo));
    } else {
        yield put(BusinessCustomersActions.businessCustomerApplyFailure(response.data, batchNo))
    }
}

export function* getCustomerRecentPayments(action) {
    const { businessCustomerId, size } = action;
    // make the call to the api
    const response = yield call(api.customerRecentPayments, businessCustomerId, size);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerPaymentsSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerPaymentsFailure(response.data))
    }
}

export function* getCustomerRecentMissedPayments(action) {
    const { businessCustomerId, size } = action;
    // make the call to the api
    const response = yield call(api.customerMissedPayments, businessCustomerId, size);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerMissedPaymentsSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerMissedPaymentsFailure(response.data))
    }
}

export function* getRecentCustomerSubscriptionActivity(action) {
    const { businessCustomerId, size } = action;
    // make the call to the api
    const response = yield call(api.customerSubscriptionActivity, businessCustomerId, size);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerSubscriptionActivitySuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerSubscriptionActivityFailure(response.data))
    }
}

export function* getCustomerReceivedPayments(action) {
    const { businessCustomerId, options } = action;
    // make the call to the api
    const response = yield call(api.customerReceivedPayments, businessCustomerId, options);
    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.customerReceivedPaymentSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.customerReceivedPaymentFailure(response.data))
    }
}

export function* getCustomerMissedPayments(action) {
    const { businessCustomerId } = action;
    // make the call to the api
    const response = yield call(api.businessCustomerMissedPayments, businessCustomerId);
    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.customerMissedPaymentSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.customerMissedPaymentFailure(response.data))
    }
}

export function* getCustomerPendingPayments(action) {
    const { businessCustomerId } = action;
    // make the call to the api
    const response = yield call(api.customerPendingPayments, businessCustomerId);
    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.customerPendingPaymentSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.customerPendingPaymentFailure(response.data))
    }
}

export function* getCustomerReports(action) {
    const { businessId, options } = action;
    // make the call to the api
    const response = yield call(api.getCustomerReport, businessId, options);
    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.customerReportSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.customerReportFailure(response.data))
    }
}
export function* getBusinessCustomerCharts(action) {
    const { businessId, duration, options } = action;
    // make the call to the api
    const response = yield call(api.getCustomerCharts, businessId, duration, options);
    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.customerChartsSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.customerChartsFailure(response.data))
    }
}
export function* getSuccessfulPayments(action) {
    const { bcId, options } = action;
    // make the call to the api
    const response = yield call(api.successfulCustomerPayments, bcId, options);
    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.successfulPaymentsSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.successfulPaymentsFailure(response.data))
    }
}
export function* getExpiredPayments(action) {
    const { bcId, options } = action;
    // make the call to the api
    const response = yield call(api.expiredCustomerPayments, bcId, options);
    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.expiredPaymentsSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.expiredPaymentsFailure(response.data))
    }
}
export function* getBusinessCustomersBulkPause(action) {
    const { membershipId, ids } = action;
    // make the call to the api
    const response = yield call(api.businessCustomersBulkPause, membershipId, ids);
    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomersBulkPauseSuccess(response.data.processed));
    } else {
        yield put(BusinessCustomersActions.businessCustomersBulkPauseFailure(response.data))
    }
}

export function* getBusinessCustomersBulkCancel(action) {
    const { membershipId, ids } = action;
    // make the call to the api
    const response = yield call(api.businessCustomersBulkCancel, membershipId, ids);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomersBulkCancelSuccess(response.data.processed));
    } else {
        yield put(BusinessCustomersActions.businessCustomersBulkCancelFailure(response.data))
    }
}
export function* getBusinessCustomersSinglePause(action) {
    const { businessCustomerId, membershipId } = action;
    // make the call to the api
    const response = yield call(api.businessCustomersSinglePause, businessCustomerId, membershipId);
    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomersSinglePauseSuccess(response.data.processed));
    } else {
        yield put(BusinessCustomersActions.businessCustomersSinglePauseFailure(response.data))
    }
}

export function* getBusinessCustomersSingleCancel(action) {
    const { businessCustomerId, membershipId } = action;
    // make the call to the api
    const response = yield call(api.businessCustomersSingleCancel, businessCustomerId, membershipId);

    // success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomersSingleCancelSuccess(response.data.processed));
    } else {
        yield put(BusinessCustomersActions.businessCustomersSingleCancelFailure(response.data))
    }
}
export function* getBusinessCustomerSubscriptionAmounts(action) {
    const { bcId } = action;
    // make the call to the api
    const response = yield call(api.getBusinessCustomerSubscriptionAmounts, bcId);

    //success?
    if (response.ok) {
        yield put(BusinessCustomersActions.businessCustomerSubscriptionAmountsSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.businessCustomerSubscriptionAmountsFailure(response.data))
    }
}

export function* getTagGroupsGraphed(action) {
    const { businessId } = action;
    // make the call to the api
    const response = yield call(api.getTagGroupsGraphed, businessId);
    //success?
    if (response.ok) {
        yield put(BusinessCustomersActions.tagGroupGraphedSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.tagGroupGraphedFailure(response.data))
    }
}

export function* createTagGroup(action) {
    const { tagGroup } = action;
    // make the call to the api
    const response = yield call(api.createTagGroup, tagGroup);
    //success?
    if (response.ok) {
        yield put(BusinessCustomersActions.createTagGroupSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.createTagGroupFailure(response.data))
    }
}
export function* createTag(action) {
    const { tag } = action;
    // make the call to the api
    const response = yield call(api.createTag, tag);
    //success?
    if (response.ok) {
        yield put(BusinessCustomersActions.createTagSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.createTagFailure(response.data))
    }
}

export function* updateTagGroup(action) {
    const { groupId, tagGroup } = action;
    // make the call to the api
    const response = yield call(api.updateTagGroup, groupId, tagGroup);
    //success?
    if (response.ok) {
        yield put(BusinessCustomersActions.updateTagGroupSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.updateTagGroupFailure(response.data))
    }
}

export function* getTagGroups(action) {
    const { businessId, options } = action;

    const response = yield call(api.getTagGroups, businessId, options);

    if (response.ok) {
        yield put(
            BusinessCustomersActions.tagGroupSuccess(
                parsePaginatedListResponse(response, options ?? {})
            )
        );
    } else {
        yield put(BusinessCustomersActions.tagGroupFailure(response.data));
    }
}

export function* searchTagGroupsByName(action) {
    const { businessId, name } = action;

    const response = yield call(api.searchTagGroupsByName, businessId, name);

    if (response.ok) {
        yield put(BusinessCustomersActions.tagGroupSearchSuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.tagGroupSearchFailure(response.data));
    }
}

export function* getTags(action) {
    const { businessId } = action;
    // make the call to the api
    const response = yield call(api.getTags, businessId);
    //success?
    if (response.ok) {
        yield put(BusinessCustomersActions.tagsSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.tagsFailure(response.data))
    }
}
export function* updateTag(action) {
    const { tagId, tag } = action;
    // make the call to the api
    const response = yield call(api.updateTag, tagId, tag);
    //success?
    if (response.ok) {
        yield put(BusinessCustomersActions.updateTagSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.updateTagFailure(response.data))
    }
}
export function* associateSubscriberToTag(action) {
    const { tagId, bcId } = action;
    // make the call to the api
    const response = yield call(api.associateSubscriberToTag, tagId, bcId);
    //success?
    if (response.ok) {
        yield put(BusinessCustomersActions.associateSubscriberToTagSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.associateSubscriberToTagFailure(response.data))
    }
}
export function* bulkAssociateSubscriberToTag(action) {
    const { tagId, bcIds } = action;
    // make the call to the api
    const response = yield call(api.bulkAssociateSubscriberToTag, tagId, bcIds);
    //success?
    if (response.ok) {
        yield put(BusinessCustomersActions.bulkAssociateSubscriberToTagSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.bulkAssociateSubscriberToTagFailure(response.data))
    }
}

export function* dissociateSubscriberFromTag(action) {
    const { tagId, bcId } = action;
    // make the call to the api
    const response = yield call(api.dissociateSubscriberFromTag, tagId, bcId);
    //success?
    if (response.ok) {
        yield put(BusinessCustomersActions.dissociateSubscriberFromTagSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.dissociateSubscriberFromTagFailure(response.data))
    }
}

export function* bulkDissociateSubscribersFromTag(action) {
    const { tagId, bcIds } = action;
    // make the call to the api
    const response = yield call(api.bulkDissociateSubscribersFromTag, tagId, bcIds);
    //success?
    if (response.ok) {
        yield put(BusinessCustomersActions.bulkDissociateSubscribersFromTagSuccess(response.data))
    } else {
        yield put(BusinessCustomersActions.bulkDissociateSubscribersFromTagFailure(response.data))
    }
}

export function* linkPlanWithBusinessCustomer(action) {
    const { planId, bcId } = action;
    const planIds = (Array.isArray(planId) ? planId : [planId])
        .map((id) => (id == null ? "" : String(id)))
        .filter(Boolean);
    if (!bcId || !planIds.length) {
        yield put(BusinessCustomersActions.linkPlanWithBusinessCustomerFailure({
            message: "A plan is required",
        }));
        return;
    }
    let lastResponse = null;
    for (const id of planIds) {
        lastResponse = yield call(api.linkPlanWithBusinessCustomer, bcId, id);
        if (!lastResponse?.ok) {
            yield put(BusinessCustomersActions.linkPlanWithBusinessCustomerFailure(lastResponse?.data));
            return;
        }
    }
    yield put(BusinessCustomersActions.linkPlanWithBusinessCustomerSuccess(lastResponse?.data));
}

export function* linkBusinessCustomerToPrimary(action) {
    const { secondaryBusinessCustomerId, primaryBusinessCustomerId, reason } = action;
    const response = yield call(
        api.linkBusinessCustomerToPrimary,
        secondaryBusinessCustomerId,
        primaryBusinessCustomerId,
        reason
    );
    if (response.ok) {
        yield put(BusinessCustomersActions.linkBusinessCustomerToPrimarySuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.linkBusinessCustomerToPrimaryFailure(response.data));
    }
}

export function* unlinkBusinessCustomerFromPrimary(action) {
    const { secondaryBusinessCustomerId } = action;
    const response = yield call(api.unlinkBusinessCustomerFromPrimary, secondaryBusinessCustomerId);
    if (response.ok) {
        yield put(BusinessCustomersActions.unlinkBusinessCustomerFromPrimarySuccess(response.data));
    } else {
        yield put(BusinessCustomersActions.unlinkBusinessCustomerFromPrimaryFailure(response.data));
    }
}

export function* getCustomerEnrichments(action) {
    const { businessId, options } = action;
    const response = yield call(api.getCustomerEnrichments, businessId, options);
    if (response.ok) {
        yield put(BusinessCustomersActions.customerEnrichmentsSuccess(
            parsePaginatedListResponse(response, options)
        ));
    } else {
        yield put(BusinessCustomersActions.customerEnrichmentsFailure(response.data));
    }
}

export function* getCustomerEnrichmentItems(action) {
    const { businessId, requestId, options } = action;
    const response = yield call(api.getCustomerEnrichmentItems, businessId, requestId, options);
    if (response.ok) {
        yield put(BusinessCustomersActions.customerEnrichmentItemsSuccess(
            parsePaginatedListResponse(response, options)
        ));
    } else {
        yield put(BusinessCustomersActions.customerEnrichmentItemsFailure(response.data));
    }
}

export function* submitCustomerEnrichment(action) {
    const { businessId, file } = action;
    const response = yield call(api.submitCustomerEnrichment, businessId, file);
    if (response.ok) {
        yield put(BusinessCustomersActions.customerEnrichmentUploadSuccess(response.data));
        yield put(BusinessCustomersActions.customerEnrichmentsRequest(businessId, {
            page: 0,
            size: 20,
            sort: "createdOn,desc",
        }));
    } else {
        yield put(BusinessCustomersActions.customerEnrichmentUploadFailure(response.data));
    }
}